import PCLNAnalytics from '@pcln/analytics'
import { v4 as uuidv4 } from 'uuid'
import { generateFlexDatesQuery, getFlexDates } from '../../services/flexDates'

/**
 * Log Price difference between Calendar price and Minimum Retail Price from Air search Response
 * */

export async function logRetailPriceWithAPGData({ searchRequest, minimumRetailPrice, tripType }) {
  if (tripType === 'MD' || !minimumRetailPrice) {
    return
  }

  try {
    let priceDifference
    let message

    const log = {
      action: 'info',
      label: 'ELASTIC-ACCURACY',
      message: 'NA',
      priceDifference: null,
      airports: '',
      validatingCarrier: '',
      tripType,
      isFirefly: "false",
      isSuperSearchBotItin: "false"
    }

    const { query } = generateFlexDatesQuery({
      requestObj: searchRequest,
      tripType,
      rangePlusMinus: 0,
      requestId: uuidv4(),
      isLoggingRequest: true,
    })

    const airportsString = buildAirportsString(searchRequest)

    const response = await getFlexDates({
      request: query,
      onlyViewers: false,
      tripType,
    })

    const apgMinPrice = response?.[0]?.minimumFare?.amtPerPax
    const currencyCode = response?.[0]?.minimumFare?.currency
    const validatingCarrier = response?.[0]?.minimumFare?.validatingCarrier
    const isFirefly = Boolean(response?.[0]?.isFirefly).toString()
    const isSuperSearchBotItin = Boolean(response?.[0]?.isSuperSearchBotItin).toString()
    const departDateMonth = new Date(response?.[0]?.dates?.[0]).getMonth() + 1

    if (apgMinPrice) {
      const minRetailPrice = Math.ceil(minimumRetailPrice)
      const calendarMinPrice = Math.ceil(apgMinPrice)
      priceDifference = calendarMinPrice - minRetailPrice

      message = getPricingMessage({ priceDifference })

      Object.assign(log, {
        priceDifference: Math.abs(priceDifference),
        message,
        minimumRetailPrice: minRetailPrice,
        calendarPrice: calendarMinPrice,
        airports: airportsString,
        validatingCarrier: validatingCarrier,
        currencyCode,
        isFirefly,
        isSuperSearchBotItin,
        departDateMonth
      })
    }

    PCLNAnalytics.log({
      ...log,
    })
  } catch (e) {
    PCLNAnalytics.log({
      action: 'error',
      label: 'ELASTIC-ACCURACY',
      error: e?.message,
      tripType,
    })
  }
}

function getPricingMessage({ priceDifference }) {
  let message = 'SAME_PRICE'
  if (priceDifference < 0) {
    message = 'LOWER_PRICE_IN_CACHE'
  }

  if (priceDifference > 0) {
    message = 'HIGHER_PRICE_IN_CACHE'
  }
  return message
}

export function buildAirportsString(searchRequest) {
  return Object.values(searchRequest?.airports || {})
    .map((airport) => airport?.airportCode || '')
    .filter((code) => code)
    .join('-')
}
